import { z } from "zod";

export const cardPaymentMethodSchema = z.object({
  line1: z.string(),
  line2: z.string().nullable(),
  type: z.enum(["card", "pix"]).nullish(),
});

export type CardPaymentMethod = z.infer<typeof cardPaymentMethodSchema>;
